import { CSSProperties, TableHTMLAttributes } from 'react';
import classNames from 'classnames';

import { isDefined } from '@/utils/is-defined';

import className from './layout-table.module.css';

interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  borderSpacingVertical?: CSSProperties['borderSpacing'];
  ignoreHeaderRowSpacing?: boolean;
  borderCollapse?: CSSProperties['borderCollapse'];
  loading?: boolean;
}

const Table = ({
  children,
  style,
  borderSpacingVertical,
  ignoreHeaderRowSpacing,
  borderCollapse,
  loading,
  ...props
}: TableProps) => {
  const hasBorderSpacing = isDefined(borderSpacingVertical);
  const ignoreRowSpacing = hasBorderSpacing && !isDefined(ignoreHeaderRowSpacing) ? true : ignoreHeaderRowSpacing;
  return (
    <table
      {...props}
      style={{
        ...style,
        ...(isDefined(borderSpacingVertical)
          ? { '--layout-table-border-spacing-vertical': borderSpacingVertical }
          : {}),
        ...(isDefined(borderCollapse) ? { '--layout-table-border-collapse': borderCollapse } : {}),
      }}
      className={classNames(
        className['bl-table'],
        {
          [className['has-border-spacing']]: hasBorderSpacing,
          [className['ignore-header-row-spacing']]: ignoreRowSpacing,
          [className['loading']]: loading,
        },
        props?.className || ''
      )}
    >
      {children}
    </table>
  );
};

export default Table;
